import React, { useEffect, useState } from 'react';
import ReusableTable from '../../components/ReusableTable';
import CreateButton from '../../components/CreateButton';
import EditButton from '../../components/EditButton';
import DeleteButton from '../../components/DeleteButton';
import ViewButton from '../../components/ViewButton';
import {
  getAreas,
  createArea,
  editArea,
  deleteArea
} from '../../services/Admin/areaService';
import {
  getCategoriasByArea,
  createCategoria,
  editCategoria,
  deleteCategoria
} from '../../services/Admin/categoriaService';

const columns = [
  { key: 'id_area', label: 'ID' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'descripcion', label: 'Descripción' },
  { key: 'estado', label: 'Estado' }
];

const formConfig = [
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'descripcion', label: 'Descripción', type: 'text' },
  { name: 'estado', label: 'Estado', type: 'number' }
];

// Configuración para Categoría
const categoriaColumns = [
  { key: 'id_categoria', label: 'ID' },
  { key: 'area_id', label: 'Area ID' },
  { key: 'nombre', label: 'Nombre' },
  { key: 'descripcion', label: 'Descripción' },
  { key: 'estado', label: 'Estado' }
];

const categoriaFormConfig = [
  { name: 'nombre', label: 'Nombre', type: 'text' },
  { name: 'descripcion', label: 'Descripción', type: 'text' },
  { name: 'estado', label: 'Estado', type: 'number' }
];

const AreaPage = () => {
  const [data, setData] = useState([]);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    getAreas()
      .then(setData)
      .catch(() => setData([]));
  }, [reload]);

  const handleCreate = async (values, onDone) => {
    const success = await createArea(values);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const handleEdit = async (id, values, onDone) => {
    const success = await editArea(id, values);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const handleDelete = async (id, onDone) => {
    const success = await deleteArea(id);
    if (success) setReload(r => !r);
    onDone(success);
  };

  const actionRender = row => (
    <>
      <EditButton
        item={row}
        formConfig={formConfig}
        onEdit={(values, onDone) => handleEdit(row.id_area, values, onDone)}
      />
      <ViewButton
        onView={() => getCategoriasByArea(row.id_area)}
        columns={categoriaColumns}
        formConfig={categoriaFormConfig}
        onCreate={createCategoria(row.id_area)}
        onEdit={editCategoria()}
        onDelete={deleteCategoria()}
      />
      <DeleteButton
        item={row}
        onDelete={onDone => handleDelete(row.id_area, onDone)}
      />
    </>
  );

  return (
    <div>
      <div style={{ overflow: 'hidden' }}>
        <CreateButton formConfig={formConfig} onCreate={handleCreate} />
      </div>
      <ReusableTable
        data={data}
        columns={columns}
        actionRender={actionRender}
      />
    </div>
  );
};

export default AreaPage;
